import axios from "axios";

export default axios.create({
    baseURL: 'https://modena.monte360.com/investor/getInterestCalculation.php',
    headers: {
        "Content-Type": "application/json",
} 
});
